import { render, staticRenderFns } from "./EditSquare.vue?vue&type=template&id=2a26ae85"
import script from "./EditSquare.vue?vue&type=script&lang=js"
export * from "./EditSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports